import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

class SelectDescansosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
    };

    this.buscarDescansos = debounce(this.buscarDescansos.bind(this), 300);
  }

  componentDidMount() {
    // Cargar los primeros 10 al abrir por primera vez
    this.buscarDescansos('');
  }

  componentDidUpdate(prevProps) {
    if(prevProps.value !== this.props.value) {
      // Si el valor cambia, reiniciar las opciones
      if(this.props.value){
        const buscarDescanso = this.state.opciones.find(descanso => descanso._id.toString() === this.props.value.toString());
        if (!buscarDescanso){
          this.buscarDescansos(this.props.value || '');
        }
      }
    }
  }

  async buscarDescansos(texto) {
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "descansos/selectDescansosItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.props.value
        },
        {
          headers: this.props.headersToken,
        }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.descansos,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar descansos:", error);
      this.setState({ opciones: [] });
    } finally {
      // Asegurar que siempre se quite el loading
      this.setState({ cargando: false });
    }
  }


  render() {
    const {
      noBuscar,
      mode,
      selectAll,
      mostrarCarga,
      onSelectAll,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode: mode,
      onSearch: this.buscarDescansos,
      // Mostrar loading cuando está cargando, o mensaje cuando no hay resultados
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: 'center', padding: '8px' }}>
          <div style={{ marginTop: '8px', fontSize: '12px', color: '#999' }}>
            Buscando descansos...
          </div>
        </div>
      ) : this.state.primerCarga ? 'No se encontraron descansos' : null,
      // Mostrar loading en el input del select
      loading: this.state.cargando,
    };

    if (mode === 'multiple') {
      propsNuevas.maxTagCount = 'responsive';
    }

    const estiloFinal = {
      color: disabled ? 'black' : 'inherit',
      backgroundColor: disabled ? (fondoBlanco ? 'white' : 'white') : null,
      borderBottom: sinBorde ? 'none' : '1px solid #E0FFFFFF',
      borderRadius: '4px',
      transition: 'border-color 0.3s ease',
      boxShadow: sinBorde ? 'none' : '0 1px 3px rgba(0, 0, 0, 0.1)',
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };


    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => (
          <Spin spinning={this.state.cargando}>
            {menu}
          </Spin>
        )}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const descanso = this.state.opciones.find((descanso) => descanso._id === value);
          this.props.onChange(value, descanso)
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((descanso) => (
          <Option key={descanso._id} value={descanso._id}>
            {descanso.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectDescansosItem;